import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Categoryscreen from "./pages/Categorypage";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Productdetails from "./pages/Productdetails";
import Cartone from "./pages/Cartpage";
import Checkoutscreen from "./pages/Checkoutpage";
import Compare from "./Components/Comparedetails/Compare";
import Trackingorderpage from "./pages/Trackingorderpage";
import SelectReturnproductpage from "./pages/SelectReturnproductpage";
import Orderdetailspage from "./pages/Orderdetailspage";
import Returnfinalpage from "./pages/Returnfinalpage";
import Wishlist from "./Components/Wishlist/Wishlist";
import Trackreturnpage from "./pages/Trackreturnpage";
import TrackreturnDetails from "./pages/TrackreturnDetailspage";
import ProductDetailstwo from "./pages/ProductDetailstwo";
import Register from "./Components/LoginRegister/Register";
import Login from "./Components/LoginRegister/Login";
import Notfound from "./pages/Notfound";
import OrderSuccesspage from "./pages/OrderSuccesspage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../src/assets/css/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PageunderConstruction from "./pages/PageunderConstruction";
import AccountRoute from "./AccountRoute";
import ForgorPassword from "./Components/LoginRegister/ForgorPassword";
import ForgorPasswordField from "./Components/LoginRegister/ForgorPasswordField";
import Result from "./pages/Result";
import ProductdamageReturnpolicy from "./pages/ProductdamageReturnpolicy";
import Privacypolicy from "./pages/Privacypolicy";
import TermsandConditions from "./pages/TermsandConditions";
import ShippingPolicy from "./pages/ShippingPolicy";
import Aboutus from "./pages/AboutUs";
import Contactus from "./pages/Contactus";
import Classificationpage from "./pages/Classificationpage";
import ArrayProductpage from "./pages/ArrayProductpage";
import Deleteaccount from "./Components/LoginRegister/Deleteaccount";
function App() {
  return (
    <BrowserRouter basename="/">
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Homepage />
            </>
          }
        ></Route>
        <Route path="/category/:category_id" element={<Categoryscreen />} />
        <Route
          path="/subcategory/:subcategory_id"
          element={<Categoryscreen />}
        />
        <Route
          path="/subchildcategory/:subchildcategory_id"
          element={<Categoryscreen />}
        />
        <Route
          path="/classification_list/:classification_id"
          element={<Classificationpage />}
        />
        <Route
          path="/array_product_page/:array_id"
          element={<ArrayProductpage />}
        />
        <Route
          path="/product-details/:product_id"
          element={
            <>
              <Productdetails />
            </>
          }
        ></Route>
        <Route
          path="/product-details-special-products/:specialproduct_id"
          element={
            <>
              <ProductDetailstwo />
            </>
          }
        ></Route>
        <Route
          path="/cart"
          element={
            <>
              <Cartone />
            </>
          }
        ></Route>
        <Route
          path="/wishlist"
          element={
            <>
              <Wishlist />
            </>
          }
        ></Route>
        <Route
          path="/checkout-screen"
          element={
            <>
              <Checkoutscreen />
            </>
          }
        ></Route>
        <Route
          path="/compare"
          element={
            <>
              <Compare />
            </>
          }
        ></Route>
        <Route
          path="/tracing-order-page/:order_id"
          element={
            <>
              <Trackingorderpage />
            </>
          }
        ></Route>
        <Route
          path="/page-under-construction"
          element={
            <>
              <PageunderConstruction />
            </>
          }
        ></Route>
        <Route
          path="/order-details-page"
          element={
            <>
              <Orderdetailspage />
            </>
          }
        ></Route>
        <Route
          path="/select-return-products"
          element={
            <>
              <SelectReturnproductpage />
            </>
          }
        ></Route>
        <Route
          path="/return-products-final"
          element={
            <>
              <Returnfinalpage />
            </>
          }
        ></Route>
        <Route path="/account" element={<AccountRoute />} />
        <Route
          path="/track-return"
          element={
            <>
              <Trackreturnpage />
            </>
          }
        ></Route>
        <Route
          path="/track-return-details"
          element={
            <>
              <TrackreturnDetails />
            </>
          }
        ></Route>
        <Route
          path="/register"
          element={
            <>
              <Register />
            </>
          }
        ></Route>
        <Route
          path="/login"
          element={
            <>
              <Login />
            </>
          }
        ></Route>
        <Route
          path="/forgot_password"
          element={
            <>
              <ForgorPassword />
            </>
          }
        ></Route>
        <Route
          path="/confirm_password"
          element={
            <>
              <ForgorPasswordField />
            </>
          }
        ></Route>
        <Route
          path="/order-success"
          element={
            <>
              <OrderSuccesspage />
            </>
          }
        ></Route>
        <Route
          path="*"
          element={
            <>
              <Notfound />
            </>
          }
        ></Route>
        <Route
          path="/result"
          element={
            <>
              <Result />
            </>
          }
        ></Route>
        <Route
          path="/product-damage-return-policy"
          element={
            <>
              <ProductdamageReturnpolicy />
            </>
          }
        ></Route>
        <Route
          path="/privacy-policy"
          element={
            <>
              <Privacypolicy />
            </>
          }
        ></Route>
        <Route
          path="/terms-condition"
          element={
            <>
              <TermsandConditions />
            </>
          }
        ></Route>
        <Route
          path="/shipping-policy"
          element={
            <>
              <ShippingPolicy />
            </>
          }
        ></Route>
        <Route
          path="/about-us"
          element={
            <>
              <Aboutus />
            </>
          }
        ></Route>
        <Route
          path="/contact-us"
          element={
            <>
              <Contactus />
            </>
          }
        ></Route>

        <Route
          path="/delete-account"
          element={
            <>
              <Deleteaccount />
            </>
          }
        ></Route>

     
      </Routes>
      <Footer />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
